import classNames from 'classnames';
import PropTypes from 'prop-types';

import * as AppPropTypes from '../../lib/PropTypes';
import { getImageAtSize } from '../../lib/utils';

import styles from '../../../styles/splashes/rhoneacademy-splash.module.scss';

const propTypes = {
    tagline: PropTypes.string,
    image: AppPropTypes.image,
    className: PropTypes.string,
};

const defaultProps = {
    tagline: null,
    image: null,
    className: null,
};

function RhoneAcademySplash({ tagline, image, className }) {
    const { url: imageUrl = null } = getImageAtSize(image) || {};
    return (
        <div className={classNames([styles.container, className])}>
            {tagline !== null ? (
                <div className={styles.tagline} dangerouslySetInnerHTML={{ __html: tagline }} />
            ) : null}
            <div className={styles.splash}>
                {imageUrl !== null ? (
                    <img src={imageUrl} className={styles.image} alt="Splash" />
                ) : null}
            </div>
        </div>
    );
}

RhoneAcademySplash.propTypes = propTypes;
RhoneAcademySplash.defaultProps = defaultProps;

export default RhoneAcademySplash;
